import Api from 'api';
import {
  ADD_USER,
  GET_USERS,
  GET_USER_BY_ID,
  MODIFY_USER,
  SET_EDITING_USER,
  SET_USERS_FILTERS,
  SET_USERS_PAGINATION,
  TOGGLE_USER,
  UPDATE_USER,
} from 'users/constants';

export const getUsers = (companyId, filters, limit, page, orderBy, order) => ({
  type: GET_USERS,
  meta: { needAuth: true },
  payload: Api.users.getUsers(companyId, filters, limit, page, orderBy, order),
});

export const addUser = (companyId, data) => ({
  type: ADD_USER,
  meta: { needAuth: true },
  payload: Api.users.addUser(companyId, data),
});

export const updateUser = (companyId, userId, data) => ({
  type: UPDATE_USER,
  meta: { needAuth: true },
  payload: Api.users.updateUser(companyId, userId, data),
});

export const toggleUser = (companyId, userId, data) => ({
  type: TOGGLE_USER,
  meta: { needAuth: true, id: userId },
  payload: Api.users.toggleUser(companyId, userId, data),
});

export const modifyUser = (data) => ({
  type: MODIFY_USER,
  payload: data,
});

export const setEditingUser = () => ({ type: SET_EDITING_USER });

export const getUserById = (companyId, userId) => ({
  type: GET_USER_BY_ID,
  meta: { needAuth: true },
  payload: Api.users.getUserById(companyId, userId),
});

export const setFilters = (data) => ({
  type: SET_USERS_FILTERS,
  payload: data,
});

export const setPagination = (data) => ({
  type: SET_USERS_PAGINATION,
  payload: data,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/users/actions/users_actions.js